import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { CTA } from '../../interfaces/CTA.interface';
import Image from '../Image/Image';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import Heading from '../Heading/Heading';
import { HeadingTypes } from '../Heading/Heading';
import Subtitle from '../Subtitle/Subtitle';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import SbImage from '../SbImage/SbImage';

interface CategoryLandingPageHeroProps {
  hero_background_image: StoryblokAsset;
  hero_overline?: string;
  hero_heading: string;
  hero_body?: string;
  hero_cta?: Blok[];
}

const CategoryLandingPageHero: React.FC<CategoryLandingPageHeroProps> = ({
  hero_background_image,
  hero_overline = undefined,
  hero_heading,
  hero_body = undefined,
  hero_cta = [],
}) => {
  return (
    <section className="relative">
      {hero_background_image?.filename && (
        <div className="absolute top-0 right-0 bottom-0 left-0 overflow-hidden">
          <SbImage asset={hero_background_image} options={{ objectFit: 'cover' }} />
        </div>
      )}
      <div className="relative min-h-[356px] py-16 bg-[#0B212E]/80 flex items-center justify-center md:min-h-[382px] lg:min-h-[438px] xl:min-h-[492px] xl:py-28">
        <Container>
          <Grid>
            <Col
              span={{ md: 10, lg: 8, xl: 6 }}
              start={{ md: 2, lg: 3, xl: 4 }}
            >
              <div className="w-full h-full flex items-center justify-center">
                <div className="w-full space-y-12">
                  <div className="space-y-8 text-center flex flex-col items-center justify-center">
                    <div className="space-y-2">
                      {hero_overline && <Subtitle text={hero_overline} />}
                      <Heading
                        text={hero_heading}
                        headingType={HeadingTypes.h1}
                      />
                    </div>
                    {hero_body && (
                      <p className="text-text/body text-lg">{hero_body}</p>
                    )}
                    {hero_cta.map((cta: Blok) => (
                      <StoryblokComponent blok={cta} key={cta._uid} />
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Grid>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(CategoryLandingPageHero, Theme.DARK));
